// extracted by mini-css-extract-plugin
export default {"main":"LandingPageLayout_main__empKn","footer":"LandingPageLayout_footer__G7MDk","footerLink":"LandingPageLayout_footerLink__xiFJw"};